import { ToInlineCommaList } from '../../../../lib/helpers/StringHelper';
import { Actions } from '../../rules/Actions';
import { toActionDisplayName } from './toActionDisplayName';

export function toActionDisplayNames(actions: string[]): string {
  if (
    actions.length === 3 &&
    actions.every((a) => [Actions.Item_Height, Actions.Item_Width, Actions.Item_Length].includes(a))
  ) {
    return 'Dimensions';
  }

  if (
    actions.length === 2 &&
    actions.every((a) => [Actions.Extra_Cover, Actions.Extra_ExtendedBaseCover].includes(a))
  ) {
    return 'Full Protection';
  }

  return ToInlineCommaList(actions.map(toActionDisplayName));
}
